import * as React from 'react';
import { FormState, FieldState } from 'formstate';

// Constants
import {} from '../../constants/routes';

// Components
import { Form, TextField } from '../../components/FormStateFields';
import Typography from '../../components/Typography';

// Utilities
import { required, mobile, between, name } from '../../utilities/validation';

// Form
class PersonalFormState {
  // Create a field
  firstName = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(2, 50), name);
  lastName = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(2, 50), name);
  mobile = new FieldState('')
    .disableAutoValidation()
    .validators(mobile);

  // Compose fields into a form
  state = new FormState({
    firstName: this.firstName,
    lastName: this.lastName,
    mobile: this.mobile
  });

  getValues() {
    return {
      firstName: this.firstName.$,
      lastName: this.lastName.$,
      mobile: this.mobile.$
    };
  }
}

// Component
export interface IProps {
  formState: PersonalFormState;
  onSubmit: React.EventHandler<React.FormEvent<HTMLFormElement>>;
}
function AccountStep({ formState, onSubmit }: IProps) {
  return (
    <Form onSubmit={onSubmit}>
      <Typography type="headline">Personal Details</Typography>
      <Typography type="subheading" color="textSecondary">
        Enter your personal information
      </Typography>
      <TextField
        label="First Name"
        type="text"
        required={true}
        fieldState={formState.firstName}
        margin="normal"
        fullWidth={true}
      />
      <TextField
        label="Last Name"
        type="text"
        required={true}
        fieldState={formState.lastName}
        margin="normal"
        fullWidth={true}
      />
      <TextField
        label="Mobile"
        type="tel"
        required={false}
        fieldState={formState.mobile}
        margin="normal"
        fullWidth={true}
      />
      <button style={{ opacity: 0, position: 'absolute' }} type="submit" />
    </Form>
  );
}

export { PersonalFormState };
export default AccountStep;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/SignUp/PersonalStep.tsx